module.exports = __webpack_public_path__ + "static/media/mobile-banner.f8c9d4f3.png";